import { HTTPVerbs, ConfigService, type RequestOptions } from '@nextgen-web-framework/core';
import { AprProps } from '../requests/aprApi/types/propTypes';

//TODO: we will remove the below constants once will get sign-off from QA on APR API direct call support
export const APR_API_VERSION = 'v1';
export const APR_SERVICE_KEY = 'comapras';
export const getAprApiReqObj = ({ aprContainerKey, channel, filter, pageName, slots }: AprProps): RequestOptions => {
  const config = ConfigService.getConfigs();

  if (config.NEXT_PUBLIC_APR_END_POINT && config.NEXT_PUBLIC_COUNTRY) {
    const params = {
      containerKey: aprContainerKey,
      channel: channel || 'desktop',
      filter: filter || {},
      pageName,
      slots: slots?.toString() || '5',
    };
    return {
      url: `${config.NEXT_PUBLIC_APR_END_POINT}/${config.NEXT_PUBLIC_COUNTRY}/api/recommender`,
      method: HTTPVerbs.POST,
      retries: 0,
      body: params as unknown as BodyInit,
    };
  }

  //TODO: we will remove the below code once will get sign-off from QA on APR API direct call support
  const params: Record<string, string> = {
    containerKey: aprContainerKey,
    channel: channel || 'desktop',
    filter: JSON.stringify(filter || {}),
    pageName,
    slots: slots?.toString() || '5',
  };
  return {
    url: `/${APR_SERVICE_KEY}/${APR_API_VERSION}/recommend`,
    method: HTTPVerbs.GET,
    retries: 0,
    params,
  };
};
